import React, { useEffect } from 'react';
import { safeRedirect } from '../utils/navigationUtils';

const PublicRoute = ({ children }) => {
  // Check if user is authenticated
  const token = localStorage.getItem('token');
  
  // Get user role to determine where to redirect
  const userData = localStorage.getItem('user');
  let userRole = '';
  
  if (userData) {
    try {
      const user = JSON.parse(userData);
      userRole = user.role?.toLowerCase();
    } catch (error) {
      console.error('Error parsing user data:', error);
    }
  }
  
  // If user is authenticated, redirect to appropriate dashboard using useEffect
  useEffect(() => {
    if (token) {
      // Use direct URL redirection to avoid React Router security issues
      switch (userRole) {
        case 'owner':
          safeRedirect('/owner-dashboard');
          break;
        case 'admin':
          safeRedirect('/admin-dashboard');
          break;
        default:
          safeRedirect('/dashboard');
          break;
      }
    }
  }, [token, userRole]);
  
  // If not authenticated, render the children (login/register pages)
  // Otherwise, render null while redirect is in progress
  return token ? null : children;
};

export default PublicRoute; 